<template lang="pug">
  .shop-by-color.container.xs-f-small.max-at-tweak
    .row
      template(v-if="loadingProductsForType")
        .carousel-wrap.xs-12.loader
          MrSpinnerVeil

      template(v-else)
        .title
          h2.intro.xs-f-xxgrande.sm-f-xxxgrande.brand-color-1.xs-12.sm-4.md-6.max-at-tweak.xs-mb-50m.f-secondary Shop By Color
          MrDropdown.filter-item.xs-12.sm-8.md-6.max-at-tweak(v-model="filter.value" :options="filter.options" :title="filter.value")

        .carousel-wrap.xs-12(v-if="products.length")
          SimpleCarouselSSR(ref="slick" :options="carouselOptions")
            ShopByCarouselCard(v-for="product in products" :key="product.id" :product="product" @open-purchase-panel="onOpenPurchasePanel" @open-playground-modal="onOpenPlaygroundModal")

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { applyMatchTypeSpecialCharacters } from '@utilities/mrVueUtils';
  import ShopByCarouselCard from './ShopByCarouselCard';
  import MrDropdown from '@components/MrDropdown';
  import MrIcon from '@components/MrIcon';
  import SimpleCarouselSSR from '@components/SimpleCarouselSSR';
  import MrSpinnerVeil from "@components/MrSpinnerVeil";

  export default {
    name: "ShopByColor",

    components: {
      MrSpinnerVeil,
      MrDropdown,
      ShopByCarouselCard,
      MrIcon,
      SimpleCarouselSSR
    },

    data() {
      return {
        filter: {
          value: 'black',
          accessor: 'color_characteristics.color_family',
          label: 'Hair Color',
          matchType: 'exact match',
          options: [
            { label: 'Black Shades', value: 'black', disabled: false },
            { label: 'Brown Shades', value: 'brown', disabled: false },
            { label: 'Red Shades', value: 'red', disabled: false },
            { label: 'Blonde Shades', value: 'blonde', disabled: false }
          ]
        },
        carouselOptions: {
          arrows: true,
          autoplay: false,
          infinite: true,
          slidesToShow: 4.5,
          dots: true,
          slidesToScroll: 1,
          accessibility: true,
          responsive: [
            {
              breakpoint: 560,
              settings: {
                arrows: false,
                dots: true,
                slidesToScroll: 1,
                slidesToShow: 1.5,
                centerMode: false,
                infinite: false,
                swipeToSlide: true,
                speed: 100
              }
            },
            {
              breakpoint: 720,
              settings: {
                arrows: false,
                dots: true,
                slidesToScroll: 1,
                slidesToShow: 2.25,
                swipeToSlide: true,
                speed: 100
              }
            },
            {
              breakpoint: 960,
              settings: {
                arrows: false,
                dots: false,
                infinite: false,
                swipeToSlide: true,
                speed: 100,
                slidesToShow: 2.5
              }
            },
            {
              breakpoint: 1256,
              settings: {
                arrows: true,
                dots: false,
                infinite: true,
                swipeToSlide: true,
                speed: 100,
                slidesToShow: 3.5
              }
            },
          ]
        },
      };
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('productCatalog', [
        'color_kit',
        'color_kit_loaded',
        'loadingProductsForType'
      ]),
      /**
       * returns an array of products that are active(status) and fulfills the user's filter criteria
       */
      products() {
        return this.color_kit.filter((d) => {
          if (d.status !== 1) {
            return false;
          }

          const matchType = this.filter.matchType;
          const userSelection = this.filter.value;
          const productValue = d.hairColorFamily.toLowerCase();
          const matchStr = applyMatchTypeSpecialCharacters(userSelection, matchType);
          return new RegExp(matchStr).test(productValue) === true;
        });
      },

      compactFilters() {
        return this.$root.windowData.breakpoint !== 'desktop';
      }
    },

    methods: {
      ...mapActions('productCatalog', ['loadProductsForType']),
      ...mapActions('pdp', ['openPlaygroundModalWTrackEvent', 'openPurchasePanelModal', 'getProductByUrlKey']),
      ...mapActions('modal', ['showPortalModal', 'hideModal']),

      async onOpenPlaygroundModal(product) {
        await this.getProductByUrlKey(product?.url_key);
        this.openPlaygroundModalWTrackEvent({
          event: 'Virtual try on page - shop by color cta clicked',
          props: {
            virtualTryOnLanding: true
          }
        });
      },

      async onOpenPurchasePanel(product) {
        let modalPayload = {
          theme: 'full-screen'
        };
        await this.getProductByUrlKey(product?.url_key);
        this.openPurchasePanelModal(modalPayload);
      }
    },

    watch: {
      products(newProducts) {
        this.filter.options.forEach(option => {
          option.disabled = true;
          for (var x = 0; x < newProducts.length; x++) {
            var productValue = this.getObjProperty(newProducts[x], this.filter.accessor);
            if (new RegExp(option.value).test(productValue)) {
              option.disabled = false;
              break;
            }
          }
          this.$refs.slick?.goTo(0);
        });
        this.trackMREvent('Virtual try on page - shop by color filter clicked');
      }
    },

    created() {
      if (!this.color_kit_loaded) {
        this.loadProductsForType('color_kit');
      }
    }
  };
</script>

<style scoped lang="stylus">
  .shop-by-color
    margin 2em auto

    .loader
      height 17em

    .title
      text-align center
      margin-bottom 1em

      .filter-item
        width 80%
        margin 0 2em
    .carousel-wrap
      margin 0.5em 0.25em

      @media mq-mobile
        position relative
        overflow hidden

  @media mq-tablet
    .shop-by-color
      margin 2em auto
      margin-top 4em
      .title
        text-align left
        margin-left 1em

        .filter-item
          float right
          width 20em
          margin 0
          padding 0

  @media mq-desktop-md-plus
    .shop-by-color
      margin 2em auto
      margin-top 4em
      padding 0.5em 3.5em
      .title
        text-align left
        margin-left 1em

        .filter-item
          float right
          width 20em
          margin 0
          padding 0
</style>